export default {
    layout: {
        loading: 'Sedang Trading',
        trading: 'Sedang Trading'
    },
    footer: {
    },
    menu: {
        home: 'Beranda',
        staking: 'Matriks',
        port: 'PORT',
        internet: 'Jaringan',
        me: 'Saya',
    },
    header: {
        selectLang: 'Pilih Bahasa',
        close: 'Tutup',
        trading: 'Perdagangan',
        dashboard: 'Dasbor',
        subscribeMatrix: 'Berlangganan Matriks',
        portTaskCenter: 'Pusat Tugas PORT',
        network: 'Jaringan',
        apiBinding: 'Ikatan API',
        gridTree: 'Pohon Grid',
        account: 'Akun',
        documents: 'Dokumen & Whitepaper',
        personalCenter: 'Pusat Pribadi',
        language: 'Bahasa'
    },
    home: {
        recently1:'Komunitas',
        staticrewares: 'Statis',
        recentlyName: 'Buku besar',
        recentlyInfo: 'Rincian Pendapatan',
        dataUpdate: 'Pembaruan Data',
        realtime: 'Realtime·BSC',
        totalRevenue: 'Total Pendapatan (USDT)',
        today: 'Hari ini',
        totalTradingVolume: 'Total Volume Perdagangan',
        todayEarn: 'Pendapatan Hari Ini',
        share: 'Bagikan ke Teman',
        shareDesc: 'Bagikan hasil untuk undang teman dan dapatkan hadiah',
        directReferrals: 'Jumlah Referensi Langsung',
        teamMembers: 'Jumlah Anggota Tim',
        thisWeek: 'Minggu ini',
        copy: 'Salin',
        recently: 'Pendapatan Terbaru',
        netIncome: 'Pendapatan Bersih',
        dailyAverage: 'Rata-rata Harian',
        quantitativeIncome: 'Kuantitatif',
        recommend: 'Rekomendasi',
        port: 'PORT',
        bonus: 'Bonus',
        all: 'Semua',
        todayTitle: 'Hari ini',
        loadingMore: 'Muat lebih banyak',
        recommendBonus: 'Bonus Rekomendasi',
        portTaskPassed: 'Tugas PORT Lulus',
        myProfit: 'Untung/Rugi Saya',
        earningOnBitDeep: 'Saya mendapat keuntungan di BitDeep',
        totalRevenueUsdt: 'Total Pendapatan · USDT',
        consecutiveDays: 'Hari Berturut-turut',
        scanToJoin: 'Pindai untuk Bergabung',
        uid: 'UID',
        referralBonus: 'Bonus Referensi',
        shareTo: 'Bagikan ke',
        eachReferral: 'Bonus Bagikan',
        screenshotAndShare: 'Tangkapan layar dan Bagikan',
        saveShareEarn: 'Simpan · Teruskan · Dapatkan Hadiah',
        period: 'Periode',
        netProfit: 'Keuntungan Bersih',
        quantReward: 'Pendapatan Kuantitatif',
        dailyBonus: 'Bonus Harian PORT',
        close: 'Tutup',
        permission: 'Izin',
        onlyEnable: 'Hanya Aktifkan',
        enterBitgetUid: 'Masukkan BITGET UID',
        slogan: 'Slogan',
        document: 'Dokumen',
        days: 'Hari',
        taskText: 'Tugas',
        minutes: 'Menit',
        decentralizedPortTech: 'Arsitektur teknologi PoRT terdesentralisasi, ekonomi token BGB, dan matriks insentif ganda.',
        auditReport: 'Laporan Audit',
        faqSupport: 'FAQ & Dukungan',
        telegram: 'Telegram',
        piece: 'Bagian',
        faq: 'Pertanyaan Umum',
       faq1: 'Bagaimana cara menghubungkan API Bitget?',
        faq1Desc: 'Buka Bitget Exchange → Pengaturan → Manajemen API untuk memperoleh API Key dan Secret. Aktifkan hanya izin Spot Trading; jangan pernah aktifkan izin withdrawal. Tempel key ke BitDeep DApp. Setelah trading uji 1 USDT selesai, binding aktif.',
        faq2: 'Apa itu PoRT (Proof of Real Trading)?',
        faq2Desc: 'PoRT adalah mekanisme inti dari "trading sebagai mining". Setiap hari sistem menggunakan Bitget API untuk otomatis melakukan beli-jual cepat pada koin yang ditentukan (mis. BGB). Saat volume melampaui Stake × 50%, sistem memverifikasi dan memicu reward harian.',
        faq3: 'Apakah perlu memantau secara manual setiap hari?',
        faq3Desc: 'Tidak perlu. Setelah API terhubung, sistem otomatis menyelesaikan tugas trading dalam jendela 24 jam. Tidak diperlukan tindakan manual; cek di menu PoRT.',
        faq4: 'Apa perbedaan antara ALPHA dan SIGMA?',
        faq4Desc: 'ALPHA (Pemula): stake 500 USDT, yield harian 0.3–1.3%, hanya 1 paket. SIGMA (Pro): stake 1.000 USDT, yield harian 0.6–1.6%, maksimal 5 paket.',
        faq5: 'Apakah dana saya aman? Bisakah platform menyentuh dana saya?',
        faq5Desc: 'Dana Anda 100% tetap di akun Bitget Anda sendiri. API hanya memberikan izin baca & spot trading; sistem tidak dapat menarik atau memindahkan modal apa pun.',
        faq6: 'Kapan pendapatan harian diselesaikan?',
        faq6Desc: 'Setelah verifikasi PoRT lolos, settlement dilakukan keesokan harinya. Sistem otomatis melepas dua hadiah: pendapatan USDT dan poin 10x Deep.',
        faq7: 'Bagaimana Scout Bonus (Hadiah Referral Langsung) dihitung?',
        faq7Desc: 'Untuk setiap akun aktif yang Anda referensikan langsung, Anda mendapat reward harian tetap: 1 USDT/hari untuk referral ALPHA (500 USDT), 2 USDT/hari untuk referral SIGMA (1.000 USDT), hingga siklus akun tersebut berakhir.',
        faq8: 'Bagaimana cara naik level (D1–D7)?',
        faq8Desc: 'Naik level berdasarkan total volume di kaki lemah (zona kecil). Misalnya: D1 butuh 2.000 USDT, D3 butuh 15.000 USDT, D7 (tertinggi) butuh 3.000.000 USDT. Semakin tinggi level, bonus selisih level semakin besar (D7 maks. 7 USDT/orang/hari).',
        faq9: 'Berapa hari satu siklus? Apa yang terjadi setelah berakhir?',
        faq9Desc: 'Satu siklus berlangsung 28 hari. Setelah siklus berakhir, Anda dapat memilih melanjutkan staking; hadiah dibayarkan berdasarkan hasil verifikasi PoRT harian aktual (yield berfluktuasi).',
        faq10: 'Apakah ada biaya untuk penarikan?',
        faq10Desc:'Biaya penarikan adalah 0. Platform mengembalikan biaya penarikan ke pool untuk menebalkan likuiditas LP, menciptakan siklus positif.',
        bigArea: 'Area Besar',
        smallArea: 'Area Kecil',
        enterWithdrawAmount: 'Masukkan jumlah penarikan',
        all: 'Semua',
        available: 'Tersedia',
        totalAmount: 'Jumlah Total',
        confirmWithdraw: 'Konfirmasi Penarikan',
        withdrawRecord: 'Riwayat Penarikan',
        withdrawn: 'Sudah Ditarik',
        quickStartGuide:'Panduan Cepat',
        whitepaperGuide:'Whitepaper & Panduan',
        whitepaper:'Whitepaper',
        downloadPdf:'Unduh'
    },
    staking: {
        selectPackage: 'Berlangganan Matriks',
        alpha: 'ALPHA',
        beginner: 'Pemula',
        sigma: 'SIGMA',
        professional: 'Profesional',
        popular: 'Paling Populer',
        dailyReturn: 'Pengembalian Harian',
        teamDepth: 'Kedalaman Tim',
        limitPurchase: 'Batas Pembelian',
        layer: 'Lapisan',
        copy: 'Bagian',
        autoRenew: 'Perpanjangan Otomatis',
        autoReinvest: 'Investasi Ulang Otomatis',
        subscribeAlpha: 'Berlangganan Alpha',
        subscribeSigma: 'Berlangganan Sigma',
        stakedAmount: 'Jumlah Staking',
        stakedAmount2: 'Periode',
        stakedAmount3: 'Pendapatan Akumulatif',
        stakingTime: 'Waktu Staking',
        maturityTime: 'Waktu Jatuh Tempo',
        redeem: 'Tebus',
        renew: 'Perpanjang',
        autoRenewActive: 'Perpanjangan Otomatis Aktif',
        autoRenewInactive: 'Perpanjangan Otomatis Tidak Aktif',
        smartContract: 'Kontrak pintar mengelola dana, dikunci dalam siklus 28 hari, dibuka saat jatuh tempo.'
    },
    me: {
        account: 'Akun',
        my: 'Saya',
        staked: 'Sudah Staking',
        points: 'Poin',
        consecutive: 'Hari Berturut-turut',
        withdraw: 'Tarik',
        language: 'Bahasa',
        simplifiedChinese: 'Bahasa Mandarin Sederhana',
        disconnectWallet: 'Putuskan Dompet',
        level: 'Level',
        joinDate: 'Tanggal Bergabung',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'Ikatan API',
        bindDesc: 'Ikat API Key bursa Anda untuk mengotorisasi perdagangan kuantitatif',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'Bursa',
        futures: 'Kontrak',
        spot: 'Spot',
        readOnly: 'Hanya Baca',
        bind: 'Ikat',
        riskNote: 'API Key hanya digunakan untuk sinkronisasi data perdagangan, tidak menyimpan informasi sensitif',
        apiConnection: 'Koneksi API',
        bindExchangeApi: 'Ikat API Bursa',
        bitDeepRead: 'BitDeep membaca aliran pesanan akun CEX Anda untuk memverifikasi bukti perdagangan nyata (PoRT).',
        noWithdraw: 'Kami tidak pernah menyentuh penarikan Anda.',
        securityTip: 'Tips Keamanan · Harap Baca dengan Seksama',
        close: 'Tutup',
        withdraw: 'Tarik',
        permission: 'Izin',
        onlyEnable: 'Hanya Aktifkan',
        spotTrading: 'Perdagangan Spot',
        read: 'Baca',
        recommendedPartner: 'Mitra Rekomendasi',
        zeroFee: '0% Biaya',
        activated: 'Diaktifkan',
        classicAccount: 'Akun Klasik',
        unifiedAccount: 'Akun Terpadu',
        bindBitgetApi: 'Ikat Bitget API',
        upcoming: 'Segera Hadir',
        underAudit: 'Sedang Diaudit',
        expected: 'Diharapkan'
    },
        port: {
        portTaskCenter: 'Pusat Tugas PORT',
        dailyTask: 'Tugas Harian',
        verify: 'Verifikasi',
        completed: 'Selesai',
        incomplete: 'Belum Selesai',
        verifyStandard: 'Standar Verifikasi',
        tradingVolume: 'Volume Perdagangan',
        today: 'Hari ini',
        deadline: 'Batas Waktu',
        reward: 'Hadiah',
        startVerify: 'Mulai Verifikasi',
        verifying: 'Sedang Verifikasi',
        verified: 'Terverifikasi',
        insufficient: 'Tidak Mencapai Standar',
        viewDetails: 'Lihat Detail',
        taskList: 'Daftar Tugas',
        allTasks: 'Semua Tugas',
        completedTasks: 'Selesai',
        pendingTasks: 'Tertunda',
        proofOfRealTrading: 'Bukti Perdagangan Nyata',
        todayTask: 'Tugas Hari Ini',
        todayStaticIncome: 'Pendapatan Statis Hari Ini',
        points: 'Poin',
        todayWindowClosesAt: 'Jendela Hari Ini Tutup pada',
        checkTaskStatus: 'Periksa Status Tugas',
        teamProgress: 'Kemajuan Tim · Hari Ini',
        realtimePortCompletion: 'Penyelesaian PORT Realtime',
        completedText: 'Selesai',
        pendingText: 'Tertunda',
        realtimeApiValidationFlow: 'Realtime · API · Alur Verifikasi',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'Jaringan',
        treeBrowser: 'Browser Pohon',
        searchAddress: 'Cari alamat 0x... atau BD-ID',
        totalTradingVolume: 'Total Volume Perdagangan',
        members: 'Anggota',
        networkStructure: 'Struktur Jaringan',
        allLevels: 'Semua Level',
        addRemark: 'Tambahkan Catatan',
        enterRemark: 'Masukkan Catatan',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
    },
    withdraw: {
        withdraw: 'Tarik',
        usdtAsset: 'Aset USDT',
        withdrawAmount: 'Jumlah Penarikan',
        availableBalance: 'Saldo Tersedia',
        fee: 'Biaya',
        actualArrival: 'Jumlah yang Diterima',
        submit: 'Kirim',
        withdrawSuccess: 'Penarikan Berhasil',
        withdrawFailed: 'Penarikan Gagal',
        processing: 'Sedang Diproses',
        completed: 'Selesai',
        withdrawHistory: 'Riwayat Penarikan'
    },
    popup: {
        taskUnfinished: 'Tugas Belum Selesai',
        taskUnfinishedDesc: 'Data perdagangan belum mencapai standar verifikasi PoRT hari ini',
        todayTradingVolume: 'Volume Perdagangan Hari Ini',
        remaining: 'Sisa',
        toComplete: 'untuk menyelesaikan tugas hari ini',
        tradingVolumeThreshold: '',
        deadline: 'Waktu tersisa hingga batas tugas',
        tryAgain: 'Coba lagi nanti',
        goTrade: 'Pergi Berdagang',
        taskCompleted: 'Tugas Diverifikasi',
        taskCompletedDesc: 'Bukti perdagangan PoRT hari ini berhasil dicatat di blockchain',
        rewardIssued: 'Hadiah Diberikan',
        complete: 'Selesai',
        shareTitle: 'Bagikan Undangan',
        shareDesc: 'Undang teman untuk mendaftar, kedua pihak mendapat hadiah',
        referralLink: 'Tautan Undangan',
        qrCode: 'Kode QR',
        copyLink: 'Salin Tautan',
    }
};
